import actionTypes from '../constants/action-types';

const getDomainList = (query) => ({
  type: actionTypes.GET_DOMAIN_LIST,
  payload: { query },
});

export default getDomainList;
